import _ from '@/assets/lib/my-lodash'
import { emitter } from '@/plugins/emitter'
const YAGI_PROFILE_KEY = 'yagiProfile'
const DEFAULT_PROFILE = {
  name: 'ヤギ',
  color: '#FFF',
  autoSaveEnabled: true
}
const Yagi = {
  install: function (Vue, _options) {
    const main = new Vue({
      data: function () {
        return {
          profile: DEFAULT_PROFILE,
          saveKey: YAGI_PROFILE_KEY,
          changeCount: 0,
          isFromMynabi: 0
        }
      },
      computed: {
        isYagiDaikon: function () {
          if (this.profile.name.indexOf('🐐大根') !== -1) {
            return true
          } else {
            return false
          }
        }
      },
      methods: {
        changeColor: function (color) {
          this.profile.color = color
        },
        defaultProfile: function () {
          return DEFAULT_PROFILE
        },
        validateProfile: function () {
          if (!this.profile.name) {
            return false
          }
          if (this.profile.name && this.profile.name.length > 16) {
            this.$message({
              type: 'error',
              message: 'ヤギの名前が長すぎます'
            })
            return false
          }
          return true
        },
        saveProfile: _.debounce(function () {
          const app = this
          if (!this.validateProfile()) return
          this.$setItem(YAGI_PROFILE_KEY, this.profile, function (err) {
            if (err) {
              console.log(err)
              app.$message({
                type: 'error',
                message: 'ヤギ情報の保存に失敗しました'
              })
            } else {
              app.$eventHub.$emit('yagi-profile-saved', app.profile)
              emitter.emit('yagi-message', {
                text: app.profile.name + 'だよ！'
              })
            }
          })
        }, 1000),
        loadProfile: function () {
          const app = this
          this.$getItem(YAGI_PROFILE_KEY, function (err, data) {
            if (err) {
              console.error(err)
              app.$message({
                type: 'error',
                message: 'ヤギ情報の読み込みに失敗しました'
              })
              app.profile = DEFAULT_PROFILE
              return
            }
            if (!data) {
              app.profile = DEFAULT_PROFILE
              // app.openYagiProfileBox()
            } else {
              app.profile = data
            }
            app.$eventHub.$emit('yagi-profile-loaded', app.profile)
          })
        },
        updateProfile: function (profile) {
          this.profile = profile
        },
        init: function () {
          this.loadProfile()
          emitter.on('backup-loaded-' + YAGI_PROFILE_KEY, this.loadProfile)
          this.$eventHub.$on('yagi-profile-saved', this.updateProfile)
          this.$eventHub.$emit('yagi-profile-initialized', this.profile)
        }
      },
      watch: {
        profile: {
          deep: true,
          handler: function (profile) {
            this.$eventHub.$on('yagi-profile-changed', profile)
            this.changeCount++
          }
        },
        changeCount: function () {
          /* 初回ロード完了時に保存が走ってしまうのでスキップ */
          if (this.changeCount < 2) {
            return
          }
          if (!this.isNowSaving) {
            this.saveProfile()
          } else {
            console.log('skip yagi profile', this.isNowSaving)
          }
        }
      }
    })
    main.init()
    Vue.prototype.$yagi = main
  }
}
export default Yagi
